module.exports = __webpack_public_path__ + "img/tire.d5c5587.webp";